export const SORT_WORKSPACE_NAME = {
    sortWorkspacesBy: 'sortWorkspacesBy',
    sortCohortsBy: 'sortCohortsBy'
};

export const GROUP_BY_FIELD_NAMES = {
    keyPeopleGroupBy: 'keyPeopleGroupBy',
    keyOrganizationsGroupBy: 'keyOrganizationsGroupBy',
    projectOwnersGroupBy: 'projectOwnersGroupBy',
    workspaceGroupBy: 'workspaceGroupBy',
    productionStatusRankOrder: 'productionStatusRankOrder',
    projectStatusRankOrder: 'projectStatusRankOrder',
    productionTypeRankOrder: 'productionTypeRankOrder',
    productionGroupsRankOrder: 'productionGroupsRankOrder',
    productionSubTypeRankOrder: 'productionSubTypeRankOrder',
    associatedOrgRankOrder: 'associatedOrgRankOrder',
    associatedOrgProductionRoleRankOrder: 'associatedOrgProductionRoleRankOrder',
    linkedPersonRankOrder: 'linkedPersonRankOrder',
    linkedPersonProductionRoleRankOrder: 'linkedPersonProductionRoleRankOrder',
    itemStatusRankOrder: 'itemStatusRankOrder',
    representativesFullNameRankOrder: 'representativesFullNameRankOrder',
    keyRolesRankOrder: 'keyRolesRankOrder',
    pageLayout: 'pageLayout',
    pageSize: 'pageSize',
    scale: 'scale'
};

export const GROUP_BY_FIELDS = {
    keyPeopleRole: 'keyPeopleRole',
    keyPeopleName: 'keyPeopleName',
    keyOrganizationRole: 'keyOrganizationRole',
    keyOrganizationName: 'keyOrganizationName',
    projectOwnersRole: 'projectOwnersRole',
    projectOwnersName: 'projectOwnersName',
    productionType: 'productionType',
    productionSubType: 'productionSubType',
    productionStatus: 'productionStatus',
    productionGroups: 'productionGroups',
    projectStatus: 'projectStatus',
    associatedOrg: 'associatedOrg',
    associatedOrgProductionRole: 'associatedOrgProductionRole',
    linkedPerson: 'linkedPerson',
    linkedPersonProductionRole: 'linkedPersonProductionRole',
    itemStatus: 'itemStatus',
    representativesFullName: 'representativesFullName',
    keyRoles: 'keyRoles',
    nameAsc: 'name_ASC',
    nameDesc: 'name_DESC',
    publicTitleAsc: 'publictitle_ASC',
    publicTitleDesc: 'publictitle_DESC',
    rankAsc: 'rank_ASC',
    rankDesc: 'rank_DESC',
    createdAsc: 'createdOn_ASC',
    createdDesc: 'createdOn_DESC',
    updatedAsc: 'updatedOn_ASC',
    updatedDesc: 'updatedOn_DESC',
    custom: 'custom'
} as const;
